module.exports = __webpack_public_path__ + "static/fonts/Mont-RegularItalic.606c9ba.woff";